<template>
  <div style="width:100%; display:block;">
    <br>
    <span style="float:left; margin-left: 10px;" class="check">
      <input v-if="pageType ==='qna'" :id="idx" class="normal-checkbox" type="checkbox" :data="idx" :checked=this.checked @click="click({type:'checkbox'})"/>
    </span>
    <span style="float:left;margin:5px;">
      <label :for="idx" >idx {{idx}}</label>
    </span>
    <label style="float: right;margin:5px;">{{ orderType === "구매대행" ? $t('menu.requestBuy') : $t('menu.requestDelivery')}}</label>
    <div class="container" >
      <table style="width:100%;">
        <td class="img-td" style="width:20%; vertical-align: middle;text-align: center;">
          <!-- <img v-if="imgUrl === undefined || imgUrl === ''" src="../../assets/logo_big.jpg" alt="geek9.kr"> -->
           <img
            :src="imgUrl || '../../assets/logo_big.jpg'"
            @error="$event.target.src = '../../assets/logo_big.jpg'"
            alt="geek9.kr"
          >
          <br><br>
          <span v-if="invoiceNumber.indexOf('http') !== -1 && (status === $t('menu.progress6') || status === $t('menu.progress7'))">
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '포스트고' && deliveryKrCompany === '우체국'" :href='postgoWoo + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a> 
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '월드익스프레스' && deliveryKrCompany === '우체국'" :href='wel + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a> 
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '아이포터' " :href='iporter + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a>
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '포스트고' && deliveryKrCompany === 'CJ대한통운'" :href='postgoCj + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a>
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '엘덱스' && deliveryKrCompany === 'CJ대한통운'" :href='eldex + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a>
          </span>
          <span v-else-if="invoiceNumber.indexOf('http') === -1 && (status === $t('menu.progress6') || status === $t('menu.progress7'))" >
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '포스트고' && deliveryKrCompany === '우체국'" :href='postgoWoo + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a> 
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '월드익스프레스' && deliveryKrCompany === '우체국'" :href='wel + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a> 
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '아이포터' " :href='iporter + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a>
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '포스트고' && deliveryKrCompany === 'CJ대한통운'" :href='postgoCj + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a>
            <a v-if="clearanceNumber !== '' && deliveryForeignCompany === '엘덱스' && deliveryKrCompany === 'CJ대한통운'" :href='eldex + clearanceNumber' target="_blank">{{ $t('common.customs') }}</a>
          </span>
        </td>
        <td style="max-width:70%;">
          <table class="dynamic-table" style="width:100%;">
            <tr style="height: 100px;">
              <td>
                <table class="order_sub_table" style="table-layout:fixed;">
                  <tbody style="text-align: left; ">
                    <tr style="height: 30px;">
                      <td class="container_sub_style">{{ $t('menu.orderDate') }} : {{this.api.getDateByFormat(orderDate, 'YYYY.MM.DD')}}</td>
                      <td class="container_sub_style">{{ $t('menu.fPrice') }} : {{fprice}}</td>
                    </tr>
                    <tr style="height: 30px;">
                      <td class="container_sub_style">
                        {{ $t('menu.price') }} : <span>{{ wonPrice === null ? $t('menu.tbd') : parseInt(wonPrice).toLocaleString() + $t('unit.won') }}</span>
                        <span class="pay-blink pay-info" v-if="this.wonPrice > 0 && this.status === $t('menu.progress1') && orderType === '구매대행'">&nbsp;{{  $t('menu.progress1') }} </span>
                      </td>
                      <td class="container_sub_style">{{ $t('menu.country') }} : {{this.api.getCountryName({country:country})}} > {{this.api.getCountryName({country:countryEnd})}}</td>
                    </tr>
                    <tr v-if="this.api.getCookies('page') === 'list'" style="height: 30px;">
                      <td class="container_sub_style" style="width: auto; overflow: hidden; max-lines: 1;">{{ $t('menu.itemName') }} : {{name}}</td>
                      <td class="container_sub_style">{{ $t('menu.quantityBuy') }}  : {{amount}} {{ $t('unit.quantity') }}</td>
                    </tr>                      
                    <tr style="height: 30px;">
                      <td class="container_sub_style" >{{ $t('menu.progressStatus') }} : 
                        <span v-if="this.status === $t('menu.progress-1')" style="font-weight: bold;">{{status}} <label v-if="!(notice === null || notice === undefined || notice == '' || notice.length > 15)" style="font-weight: normal;color:red;"> ({{ notice }})</label></span> 
                        <span v-else-if="this.status === $t('menu.progress-2')" style="font-weight: bold;">{{status}} <label v-if="!(msg === null || msg === undefined || msg == '' || msg.length > 15)" style="font-weight: normal;color:red;"> ({{ msg }})</label></span> 
                        <span v-else style="font-weight: bold;"> {{status}}</span> 
                        <input v-if="this.status === $t('menu.progress6')" class="inner_btn" @click="click({type:'cmpl'})" :value="$t('menu.received')">
                      </td>
                      <td class="container_sub_style"><a :href="url" target="_blank">{{$t('menu.url')}}</a></td>
                    </tr>
                    <tr style="height: 30px;">
                      <td class="container_sub_style">
                        {{ $t('menu.orderNumber') }} :
                        <div class="field-row">
                          <input
                            ref="innerOrderNumber"
                            class="normalInput"
                            type="text"
                            :value="orderNumber"
                          >
                          <Button
                            size="small"
                            style="min-width: 50px;"
                            :label="orderNumber ? $t('menu.mod') : $t('menu.insert')"
                            :disabled="api.getOrderStatus(status) > 4 || api.getOrderStatus(status) < 0"
                            @click="click({ type: 'orderNumber' })"
                          />
                        </div>
                      </td>
                      <td class="container_sub_style">
                        {{ $t('menu.trackingNumber') }} :
                        <div class="field-row">
                          <input
                            ref="innerTrackingNumber"
                            class="normalInput"
                            type="text"
                            :value="trackingNumber"
                          >
                          <Button
                            size="small"
                            style="min-width: 50px;"
                            :label="trackingNumber ? $t('menu.mod') : $t('menu.insert')"
                            :disabled="api.getOrderStatus(status) > 4 || api.getOrderStatus(status) < 0"
                            @click="click({ type: 'trackingNumber' })"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr style="height: 30px;">
                      <td class="container_sub_style" v-if="invoiceNumber.indexOf('index.html') !== -1 && (status === $t('menu.progress6') || status === $t('menu.progress7'))" >
                        {{ $t('menu.invoiceNumber') }} : <a :href="invoiceNumber" target="_blank">{{ clearanceNumber }}</a> 
                      </td>
                      <td class="container_sub_style" v-else-if="invoiceNumber.indexOf('발급전') !== -1 && (status === $t('menu.progress6') || status === $t('menu.progress7'))" >
                        {{ $t('menu.invoiceNumber') }} : {{ $t('menu.notIssued') }} 
                      </td>
                      <td class="container_sub_style" v-else-if="invoiceNumber.indexOf('http') !== -1 && (status === $t('menu.progress6') || status === $t('menu.progress7'))" >
                        {{ $t('menu.invoiceNumber') }} : <a :href="invoiceNumber" target="_blank">{{ invoiceNumber.split('/')[invoiceNumber.split('/').length-1] }}</a> 
                      </td>
                      <td class="container_sub_style" v-else-if="invoiceNumber.indexOf('http') === -1 && (status === $t('menu.progress6') || status === $t('menu.progress7'))" >
                        {{ $t('menu.invoiceNumber') }} : <a :href="this.api.getDeliveryUrl(invoiceNumber, deliveryKrCompany)" target="_blank">{{ invoiceNumber }}</a>
                      </td>
                      <td class="container_sub_style" >
                        <Button v-if="this.status === $t('menu.progress6') || this.status === $t('menu.progress7')" size="small" style="float:right;" @click="click({type:'review', idx:idx, name:name, url:url, country:country, imgUrl:imgUrl, fPrice:fprice, orderType:orderType})" :label="$t('menu.review')" severity="danger"  />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </table>
      <div v-if="this.orderType === '배송대행' && this.status === $t('menu.progress0')" class="no-result">{{ $t('order.msg00') }}</div>
      <div v-if="this.wonPrice > 0 && this.status === $t('menu.progress1') && orderType === '구매대행'" class="no-result">
        <p>{{parseInt(wonPrice).toLocaleString()}}{{ $t('order.msg12') }}</p>
        <p>{{ $t('order.msg01') }}</p>
        <p>{{ $t('order.msg02') }}</p>
        <p>{{ $t('order.msg13') }} : <a href="https://geek9.kr/faq" target="_blank">geek9.kr/faq</a></p>
        <p>{{ $t('menu.kakaoBank') }} 3333-24-9473287 {{ $t('menu.hanadaem') }}({{ $t('menu.geek9Representive') }})</p>
        <select v-model="pay" v-on:change="paySelected()" style="padding:5px;"> 
          <option value = "">{{ $t('menu.pay') }}</option>
          <option value = "kakao_pay_link" v-if="isMobile">{{ $t('menu.kakaoPay') }}(mobile)</option>
          <option value = "kakao_pay_qr">{{ $t('menu.kakaoPay') }}(QR)</option>
          <option value = "toss_pay_qr">{{ $t('menu.toss') }}(QR)</option>
        </select>
      </div>
      <div v-if="this.deliveryPrice2 > 0 && this.api.getOrderStatus(this.status) < 6 && this.api.getOrderStatus(this.status) > -1 && (''+progress).endsWith('1')" class="no-result">
        <p>{{ $t('order.msg03') }}</p>
        <p>{{ $t('order.msg04') }}</p>
      </div>
      <div v-if="this.status === $t('menu.progress-1')" class="no-result">
        <p>{{ $t('order.msg05') }}</p>
        <p>1. {{ $t('order.msg06') }}</p>
        <p>2. {{ $t('order.msg07') }}</p>
        <p>3. {{ $t('order.msg08') }}</p>
        <p>{{ $t('order.msg09') }}</p>
        <p>{{ $t('order.msg10') }}</p>
        <p>{{ $t('order.msg11') }}</p>
      </div>
    </div> 
  </div>
  <!-- <div id="payModal" >
    <span class="close">&times;</span>
    <img class="modal-content" id="payImg" alt="geek9.kr">
    <div id="payCaption"></div>
  </div> -->
</template>
<script>
import { ref } from 'vue'
import router from '@/router'
import { useI18n } from 'vue-i18n'

export default {
  emits: ["setValue"],
  setup() {
    const { t } = useI18n()

    const isMobile = ref(false)
    const userAgent = navigator.userAgent
    const mobileKeywords = ['Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry', 'Windows Phone']
    isMobile.value = mobileKeywords.some(keyword => userAgent.includes(keyword))
    
    return {
      isMobile, t
    }
  },
  mounted() {
    if(this.deliveryPrice2 > 0) {
      this.$emit('setValue', {type:'deliveryPrice', deliveryPrice:this.deliveryPrice2, idx:this.deliveryIdx, status:this.status})
    }
  },
  data() {
    return {
      pay:'',
      iporter: 'http://www.epantos.com/ecp/web/pr/dt/popup/dlvChaseInqPopup.do?locale=ko&quickNo=',
      wel: "http://acieshop.com/pod.html?OrderNo=",
      eldex: "http://ex.korex.co.kr:7004/fis20/KIL_HttpCallExpTrackingInbound_Ctr.do?rqs_HAWB_NO=",
      postgoWoo: "https://acieshop.com/pod.php?OrderNo=",
      postgoCj: "https://www.doortodoor.co.kr/parcel/doortodoor.do?fsp_action=PARC_ACT_002&fsp_cmd=retrieveInvNoACT&invc_no="
    }
  },
  props: {
    idx: Number,
    uid: String,
    orderDate: String,
    fprice: String,
    wonPrice: String,
    url: String,
    imgUrl: String,
    country: String,
    countryEnd: String,
    trackingNumber: String,
    status: String,
    invoiceNumber: String,
    clearanceNumber: String,
    deliveryPrice2: Number,
    amount: Number,
    name: String,
    deliveryKrCompany: String,
    deliveryForeignCompany: String,
    deliveryForeignCompanyOrderId: String,
    orderType: String,
    orderNumber: String,
    checked: Boolean,
    progress: String,
    pageType: String,
    notice: String,
    msg: String,
    index: Number,
    deliveryIdx: Number
  },
  methods: {
    phref(type) {
      const el = document.getElementById(type)
      el.scrollIntoView()
      el.setAttribute('class', 'card main blink')
    },
    async click(param) {
      const type = param.type
      if(type === 'cmpl') {
        if(confirm(`${this.t('order.msg43')}`)) {
          const id = this.api.getCookies('id')
          await this.api.axiosGql('SELECT_POINT_HISTORY', {type: 'SELECT_POINT_HISTORY', val: this.idx, id: id, pointType: `${this.t('menu.progress7')}` })
          .then( async (res) => {
            this.api.axiosGql('UPDATE_ORDER_BY_IDX', {
              type: 'UPDATE_ORDER_BY_IDX',
              idx: this.idx,
              status: 7
            }).then( async (res2) => {
              if(res2.status === 200) {
                this.emitter.emit('reload', 'dashboard')
                this.$notify(`${this.t('order.msg44')}`)
                if(res.data !== 'Dupliced in PointHistory') {
                  this.api.axiosGql('UPDATE_POINT', {type: 'UPDATE_POINT', id: this.api.getCookies('id'), point: 30} )
                  .then(async (res2) => {
                    const point = Number(res2.data.POINT)
                    // this.emitter.emit('setValue', point)
                    this.api.axiosGql('INSERT_POINT_HISTORY', {
                      type: 'INSERT_POINT_HISTORY',
                      id: this.api.getCookies('id'),
                      point: point,
                      pointType: `${this.t('menu.progress7')}`,
                      val: String(this.idx)
                    })
                  })
                } else {
                  this.$notify(`${this.t('order.msg45')}`)
                  alert(`${this.t('order.msg45')}`)
                }
              } else {
                this.$notify(`${this.t('sentence.retry')}`)
              }
            })
          })
        }
      } else if(type === 'orderNumber') {
        if(confirm(`${this.t('order.msg47')}`)) {
          const orderNumber = this.$refs.innerOrderNumber.value
          this.api.axiosGql('UPDATE_ORDER_BY_IDX', {
            type: 'UPDATE_ORDER_BY_IDX',
            idx: this.idx,
            trackingNumber:this.trackingNumber,
            orderNumber: orderNumber,
            status: this.api.getOrderStatus(this.status)
          }).then( async (res) => {
            if(res.status === 200) {
              this.$emit('setValue', {type:type, orderNumber:orderNumber, idx:this.idx})
              this.$notify(`${this.t('sentence.cmplMod')}`)
              alert(`${this.t('sentence.cmplMod')}`)
              this.modifyHistory({type:type + '-' + this.idx, before:this.orderNumber, after:orderNumber})
            } else {
              this.$notify(`${this.t('sentence.retry')}`)
              alert(`${this.t('sentence.retry')}`)
            }
          })
        }
      } else if(type === 'trackingNumber') {
        if(confirm(`${this.t('order.msg48')}`)) {
          const trackingNumber = this.$refs.innerTrackingNumber.value
          this.api.axiosGql('UPDATE_ORDER_BY_IDX', {
            type: 'UPDATE_ORDER_BY_IDX',
            idx: this.idx,
            trackingNumber: trackingNumber,
            orderNumber: this.orderNumber,
            status: this.api.getOrderStatus(this.status)
          }).then( async (res) => {
            if(res.status === 200) {
              this.$emit('setValue', {type:type, trackingNumber:trackingNumber, idx:this.idx})
              this.modifyHistory({type:type + '-' + this.idx, before:this.trackingNumber, after:trackingNumber})
              this.emitter.emit('confirm', {message: `${this.t('sentence.cmplMod')}`, header:`${this.t('menu.mod')}`, icon:'pi pi-info-circle'})
            } else {
              this.emitter.emit('confirm', {message: `${this.t('sentence.retry')}`, header:this.api.getCookies('page'), icon:'pi pi-exclamation-triangle'})
            }
          })
          if(!(trackingNumber === undefined || this.deliveryForeignCompanyOrderId === undefined || this.deliveryForeignCompanyOrderId === '')) {
            const iporterResult = await this.api.axiosGql('SELECT_IPORTER_ORDER_DTL', {type:'SELECT_IPORTER_ORDER_DTL', orderId:this.deliveryForeignCompanyOrderId, trackingNumber:trackingNumber})
            const json = iporterResult.data
            if(json.order_status !== '' && json.status === 'success') {
              await this.api.axiosGql('IPORTER_API_TRACKING_URL', {type:'IPORTER_API_TRACKING_URL', order_id:this.deliveryForeignCompanyOrderId, tracking: trackingNumber})
            }
          }
        }
      } else if(type === 'review'){
        if(confirm(`${this.t('order.msg49')}`)) {
          router.push({name:type, params:param})
        }
      } else if(type === 'checkbox') this.$emit("checkbox", {seq:this.index, idx:this.idx})
    },
    modifyHistory(param) {
      this.api.axiosGql('INSERT_ORDER_HISTORY', {type:'INSERT_ORDER_HISTORY', id: "" + this.api.getCookies('id'), uidBefore: param.before, uidAfter: param.after, content: param.type})
    },
    paySelected() {
      if(this.pay === '') return
      const payment = this.pay
      this.pay = ''
      if(payment === 'kakao_pay_link') window.open('https://qr.kakaopay.com/Ej79lhQuc', '_blank')
      else {
        // let payModal = document.getElementById("payModal")
        // let payImg = document.getElementById("payImg")
        // let captionText = document.getElementById("payCaption")
        // payModal.style.display = "block"
        // console.log(payModal)
        // let span = document.getElementsByClassName("close")[0]
        // span.onclick = function() { 
        //   payModal.style.display = "none"
        // }
        let imgSrc = ''
        // let alt = ''
        if(payment === 'kakao_pay_qr') {
          imgSrc = 'https://geek9.kr/img/kakao_pay.46960bf8.png'
          // alt = '카카오페이'
        } else if(payment === 'toss_pay_qr') {
          imgSrc = 'https://geek9.kr/img/toss_pay.41a340ba.png'
          // alt = '토스'
        }
        // payImg.src = imgSrc
        // captionText.innerHTML = alt
        const width = 500
        const height = 500

        // 화면의 중앙을 계산
        const left = (window.screen.width / 2) - (width / 2)
        const top = (window.screen.height / 2) - (height / 2)

        // 팝업 창 속성 문자열 생성
        const features = `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no,resizable=no,scrollbars=yes`;

        window.open(imgSrc, '_blank', features)
      } 
    },
  }
}
</script>
<style scoped>
.field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.pay-info {
  color: red;
}
.pay-blink {
  animation: blink-effect 1s step-end 99999;
}

.inner_btn {
  width:auto;
  font-size: 10px;
  background-color: lightsalmon;
  color: white;
  font-weight: bold;
  border-radius: 9px;
  border: 0px;
  padding: 5px;
  max-width: 60px;
  text-align: center;
  cursor: pointer;
  margin-left:10px;
  float:right;
}

.inner_text {
  max-width: 120px;
}
.modal {
  display: none; 
  position: fixed;
  z-index: 99999999; 
  padding-top: 100px; 
  left: auto; 
  top: 0;
  margin-left: -31px;
  width: 100%; 
  height: 100%;
  overflow: auto; 
  background-color: rgb(0,0,0); 
  background-color: rgba(0,0,0,0.9);
}
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

#payCaption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

.modal-content, #payCaption {  
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {-webkit-transform:scale(0)} 
  to {-webkit-transform:scale(1)}
}

@keyframes zoom {
  from {transform:scale(0)} 
  to {transform:scale(1)}
}

.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
}
</style>